/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

export interface TdIndexesAnchorProps {
  /**
   * 索引字符
   */
  index?: {
    type: null;
    value?: string | number;
  };
}
